<template>
  <div class="text-body text-black-2">
    <RouterLink :to="zone.link">{{ zone.name }}</RouterLink>
  </div>
</template>

<script setup>
import { RouterLink } from "vue-router";
defineProps({ zone: { type: Object, default: null } });
</script>
